import { Component, Input, OnInit } from '@angular/core';
import { DisruptedSeatPassenger, IbDisruptedSeatsModel, Seat, SeatSegment } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-model';
import { newAncillariesConstants } from '../../../../../ib-web-new-ancillaries-constants';
import { IbCModalService } from 'ib-web-commons/ib-modal';
import { IbDisruptedSeatsService } from '../services/ib-disrupted-seats.service';

@Component({
    selector: 'ib-disrupted-seat-option-one',
    templateUrl: './ib-disrupted-seat-option-one.component.html',
    styleUrls: []
})
export class IbDisruptedSeatOptionOneComponent implements OnInit {

    @Input() model: IbDisruptedSeatsModel;

    constructor (
        public commonsModalService: IbCModalService,
        private disruptedSeatsService: IbDisruptedSeatsService
    ) { }

    ngOnInit (): void {
        this.getSeatTypes();
    }

    private getSeatTypes (): void {
        this.model.data.info.segments.forEach((segment: SeatSegment) => {
            segment.passengers.forEach((passenger: DisruptedSeatPassenger) => {
                passenger.seats.forEach((seat: Seat) => {
                    switch(seat.type) {
                            case newAncillariesConstants.SeatFeatures.emergencyExit:
                                seat.description = 'CKIANCSEATS_SEAT_EMERGENCY_XL';
                                break;
                            case newAncillariesConstants.SeatFeatures.extraSize:
                                seat.description = 'SEATS_EXTRA_SIZE_SEAT';
                                break;
                            case newAncillariesConstants.SeatFeatures.promo:
                                seat.description = 'SEATS_SEAT_PROMO';
                                break;
                            case newAncillariesConstants.SeatFeatures.upfront:
                                seat.description = 'CKIANCSEATS_SEAT_UPFRONT';
                                break;
                            default:
                                seat.description = 'CKIANCSEATS_SEAT_STANDAR';
                                break;
                    }
                });
            });
        });

    }

    acceptSeats (): void {
        const genericModalObject = {
            title: 'SEATS_DISRUPTION_CONFIRM_NEW_SEATS_TITLE',
            body: 'SEATS_DISRUPTION_CONFIRM_NEW_SEATS_SUBTITLE',
            showCancelButton: true
        };
        this.commonsModalService.showGenericModal(genericModalObject).result.then(
            () => {
                const flowId = '';
                this.disruptedSeatsService.acceptDisruptedSeatsChanges(flowId).subscribe({
                    next: (response: IbDisruptedSeatsModel) => {
                    },
                    error: (error: IbDisruptedSeatsModel) => {
                        const genericModalObject = {
                            title: 'MODAL_ERROR_TITLE_1',
                            body: 'MODAL_ERROR_DESCRIPTION',
                            showCancelButton: true
                        };
                        this.commonsModalService.showGenericModal(genericModalObject).result.then(() => {
                            //Cerrar la modal inicial
                        }, () => {
                            //Cerrar la modal inicial
                        });
                    }
                });
            },
            () => {}
        );
    }

}

